import { PrimaryButton } from "../components/site/Buttons";
import { Seo } from "../components/site/Seo";
import { LOGO } from "../lib/site";

export default function NotFound() {
  return (
    <main data-testid="not-found-page">
      <Seo title="Page Not Found | MST — Multiple Stream Team" description="The page you are looking for could not be found." path="/404" />
      <section className="relative bg-[#020A12] min-h-[85vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 mst-dot-pattern opacity-20" />
        <div className="absolute -top-32 right-0 w-[560px] h-[560px] rounded-full bg-[#006FD6]/15 blur-3xl" />
        <div className="relative max-w-xl mx-auto px-6 text-center py-40">
          <img src={LOGO} alt="MST" className="h-12 w-auto mx-auto" />
          <p className="mt-10 text-xs font-extrabold uppercase tracking-[0.35em] text-[#00C4F4]" style={{ fontFamily: "var(--font-heading)" }}>
            404
          </p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-white">Page Not Found</h1>
          <p className="mt-6 text-[#B7C0CC] leading-relaxed">
            The page you are looking for doesn&rsquo;t exist or may have been moved.
          </p>
          <div className="mt-10">
            <PrimaryButton to="/" data-testid="not-found-home-btn">Return Home</PrimaryButton>
          </div>
        </div>
      </section>
    </main>
  );
}
